import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import {Article} from "../../../types/Article";
import useGetArticles from "../../../hooks/api/useGetArticles";

// Types ----

type ArticlesPanelProps = {
  onSelect: (article: Article) => void
  selectedItems: SelectedItemsData
  siteId?: number | null
  isMaxSelected?: boolean
}

// Component ----

function ArticlesPanel({ onSelect, selectedItems, siteId, isMaxSelected }: ArticlesPanelProps) {
  const {data: articles, isLoading} = useGetArticles({
    sites: siteId?.toString(),
    perPage: 1000,
    published: true,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!articles?.data?.length ? articles?.data.map(article => {
                const selected = isSelected(article, ENTITY_TYPES.ARTICLE, selectedItems);

                return (
                  <Card
                    key={article.id}
                    onClick={() => onSelect(article)}
                    heading={article.title}
                    footer={article.excerpt}
                    imageUrl={article.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {ArticlesPanel};